<template>
    <b-container fluid="">
        <b-button type="button" id="btn_flotante_agregar_" size="sm" variant="outline-dark"
            v-if="permisos['inventarios.rayo.sobres']?.crear || ES_ROOT" @click="abrir_modal_crear_articulo">
            <i class="fas fa-plus"></i> Agregar
        </b-button>
        <b-button type="button" id="btn_flotante_agregar_" size="sm" variant="outline-dark" v-else disabled>
            <i class="fas fa-plus"></i> Agregar
        </b-button>

        <b-row>
            <div class="col-sm-12 mt-2">
                <h3>
                    Correlativos de sobres
                </h3>
            </div>
            <div class="col-sm-12 mt-2">
                <div class="marco_sobres_">

                    <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                        <thead>
                            <tr>
                                <th style="width: 10%;text-align: center;">
                                    Iniciales
                                </th>
                                <th style="width: 60%;">
                                    Sucursal
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Inicio
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Fin
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in registros" :key="index">
                                <td style="text-align: center;">
                                    {{ item.iniciales }}
                                </td>
                                <td>
                                    {{ sucursalesMap[item.sucursal] }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.inicio }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.fin }}
                                </td>
                                <td style="text-align: center;">
                                    <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                        variant="outline-dark"
                                        v-if="permisos['inventarios.rayo.sobres']?.actualizar || ES_ROOT"
                                        @click="abrir_modal_actualizar_articulo(item)">
                                        <i class="fas fa-pen"></i>
                                    </b-button>
                                    <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                        variant="outline-dark" v-else disabled>
                                        <i class="fas fa-pen"></i>
                                    </b-button>

                                    <b-button type="button" size="sm" style="font-size: 10px;" variant="outline-dark"
                                        v-if="permisos['inventarios.rayo.sobres']?.borrar || ES_ROOT"
                                        @click="borrar_registro(item)">
                                        <i class="fas fa-trash"></i>
                                    </b-button>
                                    <b-button type="button" size="sm" style="font-size: 10px;" variant="outline-dark"
                                        v-else disabled>
                                        <i class="fas fa-trash"></i>
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-row>

        <Formulario v-if="modal_crear_articulo" v-on:salir="cerrar_modal_crear_articulo"
            v-on:actualizar="obtener_sobres" />

        <Actulizar v-if="modal_actualizar_articulo" :item="item" v-on:salir="cerrar_modal_actualizar_articulo"
            v-on:actualizar="obtener_sobres" />
    </b-container>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex'

    import Formulario from './Crear.vue'
    import Actulizar from './Actualizar.vue'
    import { pregunta } from '@/components/functions/alertas.js'

    export default {
        name: 'Lista',
        components: {
            Formulario,
            Actulizar
        },
        computed: {
            ...mapState(['permisos', 'datos_usuario', 'sucursales']),
            ...mapGetters(['ES_ROOT']),
            sucursalesMap() {
                return this.sucursales.reduce((map, sucursal) => {
                    map[sucursal.codigo] = sucursal.nombre
                    return map
                }, {})
            }
        },
        data() {
            return {
                modal_crear_articulo: false,
                modal_actualizar_articulo: false,
                item: {},
                registros: []
            }
        },
        methods: {
            cerrar_modal_crear_articulo() {
                this.modal_crear_articulo = false
            },
            abrir_modal_crear_articulo() {
                this.modal_crear_articulo = true
            },
            cerrar_modal_actualizar_articulo() {
                this.modal_actualizar_articulo = false
            },
            abrir_modal_actualizar_articulo(item) {
                this.item = item
                this.modal_actualizar_articulo = true
            },
            async obtener_sobres() {
                let f = {
                    api: `correlativo-sobres`,
                }

                let r = await this.obtener_data(f)
                this.registros = r
            },
            async borrar_registro(item) {
                pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Esta acción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                    if (i) {
                        let f = {
                            api: `correlativo-sobres/${item.documentId}`,
                        }
                        await this.borrar_data(f)
                        await this.obtener_sobres()
                    }
                })
            },
            ...mapActions(['obtener_data', 'borrar_data'])
        },
        mounted() {
            this.obtener_sobres()
        },
    }
</script>

<style>
    .marco_sobres_ {
        width: 100%;
        height: calc(100vh - 200px);
        overflow: auto;
    }

    #btn_flotante_agregar_ {
        position: absolute;
        right: 15px;
        top: 120px;
        z-index: 999;
    }
</style>
